var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6281",
    "data-name": "Group 6281",
    transform: "translate(15373 15476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4829",
    "data-name": "Rectangle 4829",
    width: 30,
    height: 30,
    transform: "translate(-15373 -15476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6280",
    "data-name": "Group 6280",
    transform: "translate(-14.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M106.227,9.1A1.53,1.53,0,0,1,104.7,7.569V1.531a1.531,1.531,0,0,1,3.061,0V7.569A1.53,1.53,0,0,1,106.227,9.1",
    transform: "translate(-15449.08 -15476)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M109.727,10.671a1.531,1.531,0,0,1-1.082-2.613L112.9,3.8a1.531,1.531,0,0,1,2.164,2.164l-4.257,4.257a1.527,1.527,0,0,1-1.082.449",
    transform: "translate(-15447.223 -15474.222)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M112.822,12.694h-1.35a1.531,1.531,0,0,1,0-3.061h1.35a1.531,1.531,0,1,1,0,3.061",
    transform: "translate(-15446.297 -15470.888)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M115.58,22.047A1.527,1.527,0,0,1,114.5,21.6l-6.427-6.428a1.53,1.53,0,1,1,2.164-2.164l6.427,6.428a1.531,1.531,0,0,1-1.082,2.613",
    transform: "translate(-15447.527 -15469.335)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M106.227,19.565a1.53,1.53,0,0,1-1.531-1.531v-1.91a1.531,1.531,0,1,1,3.061,0v1.91a1.53,1.53,0,0,1-1.531,1.531",
    transform: "translate(-15449.08 -15468.256)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M104.214,10.682a1.526,1.526,0,0,1-1.082-.449L99.217,6.317a1.53,1.53,0,0,1,2.164-2.164L105.3,8.069a1.531,1.531,0,0,1-1.082,2.613",
    transform: "translate(-15452.226 -15474.033)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M102.794,12.694H97.712a1.531,1.531,0,1,1,0-3.061h5.082a1.531,1.531,0,1,1,0,3.061",
    transform: "translate(-15453.598 -15470.888)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M98.261,23.43a1.531,1.531,0,0,1-1.082-2.613l7.987-7.987a1.53,1.53,0,1,1,2.164,2.164l-7.987,7.987a1.527,1.527,0,0,1-1.082.449",
    transform: "translate(-15453.309 -15469.43)",
    fill: "#11d88b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.aeb04e29770e1fd9c8057f970fea78bb.svg";
export { ForwardRef as ReactComponent };